import { useEffect, useState } from "react";
import { message } from "antd";

import styles from "../ingresosPOStyles.module.css";
import OrdenesServicioPOHeader from "./OrdenesServicioPOHeader";
import OrdenesServicioPOCards from "./OrdenesServicioPOCards";
import OrdenesServicioPOFilters from "./components/OrdenesServicioPOFilters";
import OrdenesServicioPOTable from "./components/OrdenesServicioPOTable";
import OrdenServicioPOForm from "./components/OrdenServicioPOForm";
import OrdenesServicioPOBulkForm from "./components/OrdenesServicioPOBulkForm";
import LeerPoPdfModal from "./components/LeerPoPdfModal";
import dayjs from "dayjs";
import { useSelector } from 'react-redux';
import { selectAppPermissions } from '../../../store/auth/selectors';
import { getOrdenesServicioPO, deleteOrdenServicioPO } from "../../../services/financiero/ingresosPO/ordenesServicioPOService";

export default function OrdenesServicioPOPage() {

  const [productos, setProductos] = useState([]);
  const [filteredProductos, setFilteredProductos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [productoEdit, setProductoEdit] = useState(null);
  const [openForm, setOpenForm] = useState(false);
  const [openBulk, setOpenBulk] = useState(false);
  const [openLeerPdf, setOpenLeerPdf] = useState(false);
  const [productosDesdeOcr, setProductosDesdeOcr] = useState(null);

  const appName = 'ordenes_servicio_ingresos_po';
  const permissions = useSelector((state) => selectAppPermissions(state, appName));
  const user = useSelector((state) => state.auth.user);
  const userLogin = user.username;
  const permissionAccess = permissions.priv_access === 'Y';
  const permissionDelete = permissions.priv_delete === 'Y';
  const permissionUpdate = permissions.priv_update === 'Y';
  const permissionInsert = permissions.priv_insert === 'Y';
  const permissionExport = permissions.priv_export === 'Y';

  const cargarProductos = async () => {
    setLoading(true);
    try {
      const res = await getOrdenesServicioPO();
      setProductos(res);
      setFilteredProductos(res);
    }
    catch {
      message.error("Error cargando órdenes de servicio");
    }
    setLoading(false);
  }

  useEffect(() => {
    cargarProductos();
  }, [])

  const handleDelete = async (record) => {
    try {
      await deleteOrdenServicioPO(record.oid, userLogin);
      message.success("Registro eliminado");
      cargarProductos();
    }
    catch {
      message.error("Error eliminando registro");
    }
  }

  const handleEdit = (record) => {
    if (!permissionUpdate) {
      message.warning("No tiene permisos para editar");
      return;
    }
    const data = {
      ...record,
      fecha_estimada_entrega: record.fecha_estimada_entrega ? dayjs(record.fecha_estimada_entrega) : null
    };
    setProductoEdit(data);
    setOpenForm(true);
  };

  const handleCreate = () => {
    if (!permissionInsert) {
      message.warning("No tiene permisos para crear");
      return;
    }
    setProductoEdit(null);
    setOpenForm(true);
  }

  const handleUsarDatosOcr = (resultado) => {
    const lineas = (resultado.lineas || []).map((l) => ({
      Numero_PO: resultado.numero_po || undefined,
      nombre_producto: l.nombre_producto_ocr,
      cantidad: l.cantidad ?? undefined,
      valor_unitario_COP: l.valor_unitario_COP ?? undefined
    }));
    setProductosDesdeOcr(lineas.length ? lineas : [{ Numero_PO: resultado.numero_po || undefined }]);
    setOpenBulk(true);
  };

  const handleFilters = (filters) => {
    let data = [...productos];

    if (filters.search) {
      data = data.filter(p => p.nombre_producto?.toLowerCase().includes(filters.search.toLowerCase()))
    }
    if (filters.po) {
      data = data.filter(p => p.Numero_PO?.toLowerCase().includes(filters.po.toLowerCase()))
    }
    if (filters.proveedor) {
      data = data.filter(p => p.oid_proveedor === filters.proveedor)
    }
    if (filters.estado) {
      data = data.filter(p => p.oid_estado === filters.estado)
    }
    if (filters.localizacion) {
      data = data.filter(p => p.localizacion?.toLowerCase().includes(filters.localizacion.toLowerCase()))
    }

    setFilteredProductos(data);
  }

  if (!permissionAccess) {
    return <div>No tiene permisos para acceder a este módulo</div>;
  }

  return (
    <div className={`container ${styles.ingresosPoModule}`}>
      <OrdenesServicioPOHeader
        onCreate={handleCreate}
        onBulkCreate={() => { setProductosDesdeOcr(null); setOpenBulk(true); }}
        onLeerPdf={() => setOpenLeerPdf(true)}
        onRefresh={cargarProductos}
        permissionInsert={permissionInsert}
      />
      <OrdenesServicioPOCards productos={filteredProductos} />
      <OrdenesServicioPOFilters
        onFilter={handleFilters}
        filteredProductos={filteredProductos}
        permissionExport={permissionExport}
      />
      <OrdenesServicioPOTable
        data={filteredProductos}
        loading={loading}
        onEdit={handleEdit}
        onDelete={handleDelete}
        permissionDelete={permissionDelete}
        permissionUpdate={permissionUpdate}
      />
      <OrdenServicioPOForm
        open={openForm}
        producto={productoEdit}
        onClose={() => setOpenForm(false)}
        onSuccess={cargarProductos}
        userLogin={userLogin}
      />
      <OrdenesServicioPOBulkForm
        open={openBulk}
        onClose={() => setOpenBulk(false)}
        onSuccess={cargarProductos}
        userLogin={userLogin}
        initialProductos={productosDesdeOcr}
      />
      <LeerPoPdfModal
        open={openLeerPdf}
        onClose={() => setOpenLeerPdf(false)}
        onUsarDatos={handleUsarDatosOcr}
      />
    </div>
  )
}
